// extracted by mini-css-extract-plugin
export default {"container":"PopularItems_container__GdgQh","items":"PopularItems_items__OeicK","itemsContainer":"PopularItems_itemsContainer__ti47L","titles":"PopularItems_titles__7fs8k"};